<template>
  <div class="row">
    <div class="col-6">
      <OrderInfoItemWrapperComponent :data-class-name="'__data-1'"
                                     :translate-key="'pickup_place'" class="col-12">
        <template #icon-item>
          <img src="/assets/images/Framelocation-icon.png" alt="location">
        </template>
        <template #order-info>
          {{ orderData.customRoutes[0].routePoint.raw.name }}, {{ orderData.customRoutes[0].routePoint.raw.formatted_address }}
        </template>
      </OrderInfoItemWrapperComponent>

      <OrderInfoItemWrapperComponent :data-class-name="'__data-3'"
                                     :translate-key="'stops'" class="col-12" v-if="wayPoints.length">
        <template #icon-item>
            <div v-show="!open">
              <img id="open-dropoffs" src="/assets/images/plus-circle-plus-svg.svg" alt="end-date-time" @click="showDropOffs()">
            </div>
            <div v-show="open">
              <img id="open-dropoffs-blue" src="/assets/images/plus-circle-plus-svg-blue.svg" alt="end-date-time" @click="showDropOffs()">
            </div>
        </template>
        <template #order-info>
          <template v-if="open">
            <template v-for="point in wayPoints" :key="point.id">
              <div class="mb-2">
                {{ point.routePoint.raw.name }}, {{ point.routePoint.raw.formatted_address }} - {{ point.arrivalTime }}
              </div>
            </template>
          </template>
          <template v-if="!open">
                {{ wayPoints.length }}
          </template>
        </template>
      </OrderInfoItemWrapperComponent>

      <OrderInfoItemWrapperComponent :data-class-name="'__data-5'"
                                     :translate-key="'final_destination'" class="col-12">
        <template #icon-item>
          <img src="/assets/images/Framedestination.png" alt="end-date-time">
        </template>
        <template #order-info>
          {{ orderData.customRoutes[[orderData.customRoutes.length - 1]].routePoint.raw.name }}, {{ orderData.customRoutes[[orderData.customRoutes.length - 1]].routePoint.raw.formatted_address }}
        </template>
      </OrderInfoItemWrapperComponent>

    </div>

    <div class="col-6">
      <OrderInfoItemWrapperComponent :data-class-name="'__data-2'"
                                     :translate-key="'departure'" class="col-12">
        <template #icon-item>
          <img src="/assets/images/Framecalendar-icon.png" alt="pickup-date-time">
        </template>
        <template #order-info>
          {{ orderData.customRoutes[0].arrivalDate }} {{ orderData.customRoutes[0].arrivalTime }}
        </template>
      </OrderInfoItemWrapperComponent>

      <OrderInfoItemWrapperComponent :data-class-name="'__data-4'"
                                     :translate-key="'arrival'" class="col-12">
        <template #icon-item>
          <img src="/assets/images/Framecalendar-icon.png" alt="end-date-time">
        </template>
        <template #order-info>
          {{ orderData.customRoutes[orderData.customRoutes.length - 1].arrivalDate }} {{ orderData.customRoutes[orderData.customRoutes.length - 1].arrivalTime }}
        </template>
      </OrderInfoItemWrapperComponent>

      <OrderInfoItemWrapperComponent :data-class-name="'__data-6'"
                                     :translate-key="'passengers'" class="col-12">
        <template #icon-item>
          <img src="/assets/images/Framepeople-icon.png" alt="people-count">
        </template>
        <template #order-info>
          {{ orderData.passengerCount }}
        </template>
      </OrderInfoItemWrapperComponent>
    </div>
  </div>

  <div class="col-sm-12 col-md-12 col-lg-11 hr-line"></div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import './driverTrueWrapper.scss';
// @ts-ignore
import OrderInfoItemWrapperComponent from "../../orderInfoItemWrapper/OrderInfoItemWrapperComponent.vue";
import {dateHelpers} from "../../../../helpers/dateHelpers";
export default defineComponent({
  name: 'DriverTrueWrapperComponent',
  computed: {
    dateHelpers() {
      return dateHelpers
    }
  },
  components: {
    OrderInfoItemWrapperComponent
  },
  props: {
    orderData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      wayPoints: <{}[]>[],
      open: <boolean> false,
    }
  },

  methods: {
    showDropOffs(): void {
      this.open = !this.open;
    }
  },

  created() {
    this.wayPoints = [...this.orderData.customRoutes.filter((el, index) => index !== 0 && index !== this.orderData.customRoutes.length - 1)];
  },

})
</script>

<style scoped>

</style>